import React from 'react';
import { Button } from 'antd';
import i18n from '../../utils/i18n';
import { useTranslation } from 'react-i18next';
import './index.scss';

const HeaderLanguageSwitch: React.FC = () => {
  const { t } = useTranslation();
  const switchToJa = () => i18n.changeLanguage('ja');
  const switchToZh = () => i18n.changeLanguage('zh');

  return (
    <div className='header-language-switch'>
      <Button onClick={switchToZh}>中文</Button>
      <Button onClick={switchToJa} style={{ marginLeft: 8 }}>
        日本語
      </Button>
    </div>
  );
};

export default HeaderLanguageSwitch;